import React from "react";
import {useSelector} from "react-redux";
import NotesList from "../components/notes/NotesList";
import NoteForm from "../components/notes/NoteForm";

const NotesTab = () => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });
  const [notes, setNotes] = React.useState([]);
  const [totalPages, setTotalPages] = React.useState(1);
  const [currentPage, setCurrentPage] = React.useState(1);

  const fetchNotes = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/notes.json`,
      data: {page: currentPage},
      success: (response) => {
        setNotes(response.notes);
        setTotalPages(response.total_pages);
        setCurrentPage(response.current_page);
      }
    })
  }

  React.useEffect(() => {
    fetchNotes();
  }, [currentPage]);

  return <div>
    <NoteForm
      setNotes={setNotes}
      organizationName={state.organizationName}
      affiliateMemberId={state.affiliateMemberId}
    />
    <NotesList
      notes={notes}
      totalPages={totalPages}
      setNotes={setNotes}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
    />
  </div>
}

export default NotesTab;
